<section class="mt-4">
  <div class="scrollmenu">
      <!-- <a [routerLink]="['/PayOut/NewPayOutContact']">Payout Contact</a>
      <a routerLinkActive = "active" class="active menu"  [routerLink]="['/PayOut/AccountBalance']">Account Balance</a>
      <a [routerLink]="['/PayOut/ManagePayOutBulkUploadFiles']">Bulk File Upload</a> -->
      <a routerLinkActive = "active" class="active menu"  [routerLink]="['/PayOut/AccountBalance']">Account Balance</a>

      <a [routerLink]="['/PayOut/ManagePayOutContact']">PayOut Contact</a>
      <a [routerLink]="['/PayOut/BeneficiaryList']">PayOut Beneficiary</a>

      <!-- <a [routerLink]="['/PayOut/PayoutLedgers']">PayOut Ledger</a> -->
       <a [routerLink]="['/PayOut/PayOutTransactions']">PayOut Transaction</a>
      <a [routerLink]="['/PayOut/PayOutBatches']">PayOut settlement</a>
      <!-- <a [routerLink]="['/PayOut/managePayoutAccountdetails']">Payout Security</a> -->
      <!-- <a [routerLink]="['/PayOut/PayoutPostback']">PayOut PostBack Url</a> -->
<a [routerLink]="['/PayOut/ManagePayOutBulkUploadFiles']">Bulk File Upload</a>
<!-- <a [routerLink]="['/PayOut/PayoutReports']">Reports</a> -->
<!-- <a [routerLink]="['/PayOut/PayoutSecurityTransactions']">Payout Security Transactions</a> -->
  </div>
</section>
<section class="mt-5">
  <div class="">
      <div class="row">
        <div class="col-md-12 pb-4">
          <div class="text-right">
            <a href="" class="back-tour mr-3" type="a"   data-bs-toggle="modal" data-bs-target="#exampleModalCenter"> <i class="fa fa-info-circle" aria-hidden="true"></i> &nbsp; Need Assistance? Let's Explore <i
              class="far fa-lightbulb"></i></a>

          </div>
          <div class="row" *ngIf="Workclose">
            <div class="col-md-12 ">

            <div class="row">
            <div class="col-lg-12">
              <div class="card-1 px-1 p-4">
                <div >
                    <div class="row">
                        <div class="col-md-12 py-3">
                            <div class="d-inline">
                                <h3 class="font-26 gary-t text-center font600" >How it Works</h3>
                               </div>
                                <a class="d-inline float-right font-16 blue1-t" (click)="close()" style="margin-top:-25px;color: #442B66;">Close</a>
                        </div>

                    </div>

                   <div class="row hw-bg">
                       <div class="col-md-4">
                           <div class="text-center">
                             <img src="assets/img/new/add-bal.png">

                           </div>
                       </div>
                       <div class="col-md-4">
                        <div class="text-center">
                            <img src="assets/img/new/create-user.png">
                          </div>
                       </div>
                       <div class="col-md-4">
                        <div class="text-center">
                            <img src="assets/img/new/transfer-icon.png">
                          </div>
                       </div>
                   </div>
                   <div class="row text-center">

                       <div class="col-md-4">
                        <div class="py-3">

                            <p class="lite-gray-t">Add funds to your FastSwiff account</p>
                        </div>
                       </div>
                       <div class="col-md-4">
                        <div class="py-3">

                            <p class="lite-gray-t">Create a Payout contact and start making Payouts by entering payee's account details in minutes</p>
                        </div>
                       </div>
                       <div class="col-md-4">
                        <div class="py-3">

                            <p class="lite-gray-t">Make a Payout by selecting payment type and initiate the transfer</p>
                        </div>
                       </div>
                   </div>

                </div>
            </div>

            <!-- end card -->
            </div>
            </div>

            </div>
            </div>
        </div>
        <div class="col-md-12 pb-4" *ngIf="ZerpProcessors">

            <div class="card-1 px-1 p-4">
              <div class="py-3 text-center">
                <h5>Payout Configuration is not setup,Please contact Admin</h5>
            </div>

            </div>
        </div>
        <div class="col-md-12" *ngIf="!ZerpProcessors">
          <tabset [justified]="true" class="ie-fix-flex">
            <tab *ngIf="IndusTab">
              <ng-template tabHeading><button class="btn-block btn vbt-btn   " id="cardpaymentprocessorbtn"  (click)="gotoIndusCardProcessing()"> Indus Bank </button> </ng-template>
              <div class="" *ngIf="IndusBankInfo">
                <!-- <div class="col-md-8 offset-md-2" *ngIf="IndusBankInfo"> -->
              <div class="card-1">

                  <h4 class="gary-t pt-35 font-20">View Account Balance </h4>
                  <div class="pt-35">
                      <div *ngIf="IndusBalancedetails">
                        <div class="row">
                          <div class="col-md-6 offset-md-3">
                            <div class=" text-center " style="border:1px solid blue; border-radius: 25px; ">
                            <div style="padding: 32px;">
                              <h4 class="bal-a robot mb-0">{{IndusCurrentBalance | currency:"₹"}}</h4>
                              <p class="mb-0 text-center">Current Balance</p>

                            </div>
                            <div class="bg-light py-2" style="border-bottom-left-radius: 25px;
                            border-bottom-right-radius: 25px;
                        ">
                              <p class="mb-0  text-left px-2">UpdatedDatetime <span class="float-right">{{IndusUpdatedDatetime| date:'d/M/yy, h:mm a' }}</span></p>
                            </div>
                            </div>

                          </div>
                        </div>
                        <div class="row  m-3">

                          <div class="col-4 p-0"> <label  class="gary-t  l-h21 font-14 mb-3">Virtual Account No:</label> </div>

                          <div class="col-7 p-0 view-text" *ngIf="Accountnumber"> {{IndusAccountNo }}</div>
                          <div class="col-7 p-0 view-text" *ngIf="Masknumber"> XXX-XXX-XXX </div>

                      </div>
                      <div class="row  m-3">

                        <div class="col-4 p-0"> <label  class="gary-t  l-h21 font-14 mb-3">Account Id:</label> </div>

                        <div class="col-7 p-0 view-text robot"> {{IndusPayoutAccountKeyId}}</div>
                    </div>
                    <div class="row  m-3">

                      <div class="col-4 p-0"> <label  class="gary-t  l-h21 font-14 mb-3">Bank Name:</label> </div>

                      <div class="col-7 p-0 view-text"> {{IndusBankRefereceId }}</div>
                  </div>



                    <div class="row  m-3" *ngIf="Accountnumber">

                        <div class="col-4 p-0"> <label  class="gary-t  l-h21 font-14 mb-3">Account HolderName:</label> </div>

                        <div class="col-7 p-0 view-text robot"> {{IndusAccountHolderName}}</div>
                    </div>
                    <div class="row  m-3" *ngIf="Accountnumber">

                        <div class="col-4 p-0"> <label  class="gary-t  l-h21 font-14 mb-3">Bank Code/IFSC Code:</label> </div>

                        <div class="col-7 p-0 view-text robot"> {{IndusBankCode}}</div>
                    </div>
                    <div class="row  m-3" *ngIf="Accountnumber">

                        <div class="col-4 p-0"> <label  class="gary-t  l-h21 font-14 mb-3">Address:</label> </div>

                        <div class="col-7 p-0 view-text robot"> {{IndusAddress}}, {{IndusCity}},
                            {{IndusState}}, {{IndusZipCode}},</div>
                    </div>

                          <a href="javascript:" class="back-tour mr-3" type="a" (click)="TransactionHistory()"  >Recent Transactions </a>
                      </div>
                      <div class="text-center" *ngIf="Indusinvalidetails">
                          <label>"Note : Account details are not present,Click on create virtual account" </label>
                      </div>
                      <div class="text-left pt-3" *ngIf="Indusinvalidetails">

                          <button class="btn box-button px-4 py-2" id="Savecoupon" color="primary"
                               (click)="Createbalance(1)" *ngIf="CreateAccount && hidevirtualacct">Create Virtual Account</button>


                      </div>
                      <div class="text-right pt-3" *ngIf="Indusbtn && IndusBalancedetails">

                        <button class="btn box-button px-4 py-2" id="Savecoupon" color="primary"
                             (click)="opendialogbox(1)">Set As Default Account</button>



                    </div>
                  </div>
              </div>
              </div>
            </tab>


            <tab *ngIf="YesBankTab">
              <ng-template tabHeading><button class="btn-block btn vbt-btn   " id="gotoAxisCardProcessing"  (click)="gotoYesbankprocessor()"> Yes Bank </button> </ng-template>
              <div class="col-md-8 offset-md-2" *ngIf="yesBankInfo">
                <div class="card-1">

                    <h4 class="gary-t pt-35 font-20">View Account Balance </h4>
                    <div class="pt-35">
                        <div *ngIf="YesBankBalancedetails">
                          <div class="row">
                            <div class="col-md-6 offset-md-3">
                              <div class=" text-center " style="border:1px solid blue; border-radius: 25px; ">
                              <div style="padding: 32px;">
                                <h4 class="bal-a robot mb-0">{{YesBankCurrentBalance | currency:"₹"}}</h4>
                                <p class="mb-0 text-center">Current Balance</p>

                              </div>
                              <div class="bg-light py-2" style="border-bottom-left-radius: 25px;
                              border-bottom-right-radius: 25px;">
                                <p class="mb-0  text-left px-2">UpdatedDatetime <span class="float-right">{{YesBankUpdatedDatetime| date:'d/M/yy, h:mm a' }}</span></p>
                              </div>
                              </div>

                            </div>
                          </div>
                          <div class="row  m-3">

                            <div class="col-4 p-0"> <label  class="gary-t  l-h21 font-14 mb-3">Virtual Account No:</label> </div>

                            <div class="col-7 p-0 view-text" *ngIf="Accountnumber"> {{YesBankAccountNo }}</div>
                            <div class="col-7 p-0 view-text" *ngIf="Masknumber"> XXX-XXX-XXX </div>

                        </div>
                        <div class="row  m-3">

                          <div class="col-4 p-0"> <label  class="gary-t  l-h21 font-14 mb-3">Account Id:</label> </div>

                          <div class="col-7 p-0 view-text robot"> {{YesPayoutAccountKeyId}}</div>
                      </div>

                        <div class="row  m-3">

                          <div class="col-4 p-0"> <label  class="gary-t  l-h21 font-14 mb-3">Bank Name:</label> </div>

                          <div class="col-7 p-0 view-text"> {{YesBankBankRefereceId}}</div>
                      </div>

                        <div class="row  m-3" *ngIf="Accountnumber">

                            <div class="col-4 p-0"> <label  class="gary-t  l-h21 font-14 mb-3">Account HolderName:</label> </div>

                            <div class="col-7 p-0 view-text robot"> {{YesBankAccountHolderName}}</div>
                        </div>
                        <div class="row  m-3" *ngIf="Accountnumber">

                            <div class="col-4 p-0"> <label  class="gary-t  l-h21 font-14 mb-3">Bank Code/IFSC Code:</label> </div>

                            <div class="col-7 p-0 view-text robot"> {{YesBankBankCode}}</div>
                        </div>
                        <div class="row  m-3" *ngIf="Accountnumber">

                            <div class="col-4 p-0"> <label  class="gary-t  l-h21 font-14 mb-3">Address:</label> </div>

                            <div class="col-7 p-0 view-text robot"> {{YesBankAddress}}, {{YesBankCity}},
                                {{YesBankState}}, {{YesBankZipCode}},</div>
                        </div>


                            <a href="javascript:" class="back-tour mr-3" type="a" (click)="TransactionHistory()"  >Recent Transactions </a>
                        </div>
                        <div class="text-center" *ngIf="YesBankinvalidetails">
                            <label>"Note : If Account details are not present then Create One Beneficiary" </label>
                        </div>
                        <div class="text-left pt-3" *ngIf="YesBankinvalidetails">

                            <button class="btn box-button px-4 py-2" id="Savecoupon" color="primary"
                                 (click)="Createbalance(2)" *ngIf="CreateAccount  && hidevirtualacct">Create Virtual Account</button>


                        </div>
                        <div class="text-right pt-3" *ngIf="YesBankbtn && YesBankBalancedetails">

                          <button class="btn box-button px-4 py-2" id="Savecoupon" color="primary"
                               (click)="opendialogbox(2)">Set As Default Account</button>



                      </div>
                    </div>
                </div>
            </div>
            </tab>






            <tab *ngIf="AxisTab">
              <ng-template tabHeading><button class="btn-block btn vbt-btn   " id="gotoAxisCardProcessing"  (click)="gotoAxisCardProcessing()"> Axis Bank </button> </ng-template>
              <div class="col-md-8 offset-md-2" *ngIf="AxisBankInfo">

                <div class="card-1">

                    <h4 class="gary-t pt-35 font-20">View Account Balance </h4>
                    <div class="pt-35">
                        <div *ngIf="AxisBalancedetails">
                          <div class="row">
                            <div class="col-md-6 offset-md-3">
                              <div class=" text-center " style="border:1px solid blue; border-radius: 25px; ">
                              <div style="padding: 32px;">
                                <h4 class="bal-a robot mb-0">{{AxisBankCurrentBalance | currency:"₹"}}</h4>
                                <p class="mb-0 text-center">Current Balance</p>

                              </div>
                              <div class="bg-light py-2" style="border-bottom-left-radius: 25px;
                              border-bottom-right-radius: 25px;
                          ">
                                <p class="mb-0  text-left px-2">UpdatedDatetime <span class="float-right">{{AxisBankUpdatedDatetime| date:'d/M/yy, h:mm a' }}</span></p>
                              </div>
                              </div>

                            </div>
                          </div>
                          <div class="row  m-3">

                            <div class="col-4 p-0"> <label  class="gary-t  l-h21 font-14 mb-3">Virtual Account No:</label> </div>

                            <div class="col-7 p-0 view-text" *ngIf="Accountnumber"> {{AxisBankAccountNo }}</div>
                            <div class="col-7 p-0 view-text" *ngIf="Masknumber"> XXX-XXX-XXX </div>

                        </div>

                        <div class="row  m-3">

                          <div class="col-4 p-0"> <label  class="gary-t  l-h21 font-14 mb-3">Account Id:</label> </div>

                          <div class="col-7 p-0 view-text robot"> {{AxisPayoutAccountKeyId}}</div>
                      </div>
                        <div class="row  m-3">

                          <div class="col-4 p-0"> <label  class="gary-t  l-h21 font-14 mb-3">Bank Name:</label> </div>

                          <div class="col-7 p-0 view-text"> {{AxisBankBankRefereceId }}</div>
                      </div>


                        <div class="row  m-3" *ngIf="Accountnumber">

                            <div class="col-4 p-0"> <label  class="gary-t  l-h21 font-14 mb-3">Account HolderName:</label> </div>

                            <div class="col-7 p-0 view-text robot"> {{AxisBankAccountHolderName}}</div>
                        </div>
                        <div class="row  m-3" *ngIf="Accountnumber">

                            <div class="col-4 p-0"> <label  class="gary-t  l-h21 font-14 mb-3">Bank Code/IFSC Code:</label> </div>

                            <div class="col-7 p-0 view-text robot"> {{AxisBankBankCode}}</div>
                        </div>
                        <div class="row  m-3" *ngIf="Accountnumber">

                            <div class="col-4 p-0"> <label  class="gary-t  l-h21 font-14 mb-3">Address:</label> </div>

                            <div class="col-7 p-0 view-text robot"> {{AxisBankAddress}}, {{AxisBankCity}},
                                {{AxisBankState}}, {{AxisBankZipCode}},</div>
                        </div>
                            <a  href="javascript:" class="back-tour mr-3" type="a" (click)="TransactionHistory()"  >Recent Transactions </a>
                        </div>
                        <div class="text-center" *ngIf="Axisinvalidetails">
                            <label>"Note : If Account details are not present then Create One Beneficiary" </label>
                        </div>
                        <div class="text-left pt-3" *ngIf="Axisinvalidetails">

                            <button class="btn box-button px-4 py-2" id="Savecoupon" color="primary"
                                 (click)="Createbalance(3)" *ngIf="CreateAccount  && hidevirtualacct">Create Virtual Account</button>


                        </div>
                        <div class="text-right pt-3" *ngIf="Axiskbtn && AxisBalancedetails">

                          <button class="btn box-button px-4 py-2" id="Savecoupon" color="primary"
                               (click)="opendialogbox(3)">Set As Default Account</button>



                      </div>
                    </div>
                </div>
            </div>
            </tab>


            <tab *ngIf="IDFCTab">
              <ng-template tabHeading><button class="btn-block btn vbt-btn   " id="gotoAxisCardProcessing"  (click)="gotoIDFCCardProcessing()"> IDFC Bank </button> </ng-template>           
              <div class="col-md-8 offset-md-2" *ngIf="IDFCInfo">

                <div class="card-1">
                   
                    <h4 class="gary-t pt-35 font-20">View Account Balance </h4>
                    <div class="pt-35">
                        <div *ngIf="IDFCBankBalancedetails">
                          <div class="row">
                            <div class="col-md-6 offset-md-3">
                              <div class=" text-center " style="border:1px solid blue; border-radius: 25px; ">
                              <div style="padding: 32px;">
                                <h4 class="bal-a robot mb-0">{{IDFCBankCurrentBalance | currency:"₹"}}</h4>
                                <p class="mb-0 text-center">Current Balance</p>
                              
                              </div>
                              <div class="bg-light py-2" style="border-bottom-left-radius: 25px;
                              border-bottom-right-radius: 25px;
                          ">  
                                <p class="mb-0  text-left px-2">UpdatedDatetime <span class="float-right">{{IDFCBankUpdatedDatetime| date:'d/M/yy, h:mm a' }}</span></p>
                              </div>
                              </div>
                             
                            </div>
                          </div>
                          <div class="row  m-3">
    
                            <div class="col-4 p-0"> <label  class="gary-t  l-h21 font-14 mb-3">Virtual Account No:</label> </div>

                            <div class="col-7 p-0 view-text" *ngIf="Accountnumber"> {{IDFCBankAccountNo }}</div>
                            <div class="col-7 p-0 view-text" *ngIf="Masknumber"> XXX-XXX-XXX </div>

                        </div>

                        <div class="row  m-3">

                          <div class="col-4 p-0"> <label  class="gary-t  l-h21 font-14 mb-3">Account Id:</label> </div>

                          <div class="col-7 p-0 view-text robot"> {{IDFCPayoutAccountKeyId}}</div>
                      </div>
                        <div class="row  m-3">

                          <div class="col-4 p-0"> <label  class="gary-t  l-h21 font-14 mb-3">Bank Name:</label> </div>

                          <div class="col-7 p-0 view-text"> {{IDFCBankBankRefereceId }}</div>
                      </div>
                   

                        <div class="row  m-3" *ngIf="Accountnumber">

                            <div class="col-4 p-0"> <label  class="gary-t  l-h21 font-14 mb-3">Account HolderName:</label> </div>

                            <div class="col-7 p-0 view-text robot"> {{IDFCBankAccountHolderName}}</div>
                        </div>
                        <div class="row  m-3" *ngIf="Accountnumber">

                            <div class="col-4 p-0"> <label  class="gary-t  l-h21 font-14 mb-3">Bank Code/IFSC Code:</label> </div>

                            <div class="col-7 p-0 view-text robot"> {{IDFCBankBankCode}}</div>
                        </div>
                        <div class="row  m-3" *ngIf="Accountnumber">

                            <div class="col-4 p-0"> <label  class="gary-t  l-h21 font-14 mb-3">Address:</label> </div>

                            <div class="col-7 p-0 view-text robot"> {{IDFCBankAddress}}, {{IDFCBankCity}},
                                {{IDFCBankState}}, {{IDFCBankZipCode}},</div>
                        </div>
                            <a class="back-tour mr-3" type="a" (click)="TransactionHistory()"  >Recent Transactions </a>
                        </div>
                        <div class="text-center" *ngIf="IDFCBankinvalidetails">
                            <label>"Note : If Account details are not present then Create One Beneficiary" </label>
                        </div>
                        <div class="text-left pt-3" *ngIf="IDFCBankinvalidetails">
    
                            <button class="btn box-button px-4 py-2" id="Savecoupon" color="primary"
                                 (click)="Createbalance(4)" *ngIf="CreateAccount  && hidevirtualacct">Create Virtual Account</button>
    
    
                        </div>
                        <div class="text-right pt-3" *ngIf="IDFCkbtn && IDFCBankBalancedetails">
  
                          <button class="btn box-button px-4 py-2" id="Savecoupon" color="primary"
                               (click)="opendialogbox(4)">Set As Default Account</button>
  
  
                               
                      </div>
                    </div>
                </div>
            </div>
            </tab>
            
            </tabset>

        </div>
      </div>
  </div>



      <div class="col-md-12 p-0 mt-2" *ngIf="transactiondetails">
          <div>
            <ngx-datatable #table class='bootstrap no-detail-row' (columnMode)="'Force'" [footerHeight]="50"
            [rowHeight]="'auto'"[columnMode]="'force'" [scrollbarH]="true" [limit]="10" [rows]="TransactionList">
            <ngx-datatable-column name="Action">
              <ng-template let-row="row" ngx-datatable-cell-template>
                  <a class=" edit" [routerLink]="['/PayOut/ViewPayOutTransactions',{Id: row.TransactionId}]" data-toggle="tooltip"
                  data-placement="top" title="View">
                  <img src="./assets/ViewDetails.svg">
                </a>

              </ng-template>
            </ngx-datatable-column>


            <ngx-datatable-column name="Status" [width]="180">
              <ng-template let-row="row" ngx-datatable-cell-template>
                <span class="status-warning-btn" *ngIf="row.Status==0">
                  Pending
                </span>
                <span class="status-primary-btn" *ngIf="row.Status==1">
                  Transaction Initiated
                </span>
                <span class="status-danger-btn" *ngIf="row.Status==2">
                  Failed
                </span>
                <span class="status-approved-btn" *ngIf="row.Status==3">
                  Transferred
                </span>
                <span class="status-danger-btn" *ngIf="row.Status==4">
                  Cancelled
                </span>
                <span class="status-danger-btn" *ngIf="row.Status==5">
                  WaitingForApproval
                </span>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="Amount">
              <ng-template let-row="row" ngx-datatable-cell-template><div class=" text-right robot font400"> {{row.Amount | currency:"₹" }}</div></ng-template>
            </ngx-datatable-column>

            <!-- [width]="200" -->
            <ngx-datatable-column name="Transaction Id"  [width]="200">
              <ng-template let-row="row" ngx-datatable-cell-template> {{row.TransactionId}}
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="Account Number"  [width]="200">
              <ng-template let-row="row" ngx-datatable-cell-template> {{row.AccountNumber}}
              </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Beneficiary Name">
              <ng-template let-row="row" ngx-datatable-cell-template> {{row.BeneficiaryName}} </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Bank Name">
              <ng-template let-row="row" ngx-datatable-cell-template> {{row.BankName}} </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column name="Transaction Type">
              <ng-template let-row="row" ngx-datatable-cell-template> <div class="robot font400">{{row.TransactionType}}</div>
              </ng-template>

            </ngx-datatable-column>
            <ngx-datatable-column name="Payment Type">
              <ng-template let-row="row" ngx-datatable-cell-template> {{row.PaymentType}}
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="Reason">
              <ng-template let-row="row" ngx-datatable-cell-template> {{row.InternalPurpose}} </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="Payout Processor" [width]="180">
              <ng-template let-row="row" ngx-datatable-cell-template>
                <span class="" *ngIf="row.PayoutProcessor==0">
                  FastSwiffDemo
                </span>
                <span class="" *ngIf="row.PayoutProcessor==1">
                  Indusind
                </span>
                <span class=""  *ngIf="row.PayoutProcessor==2">
                  YesBank
                </span>
                <span class="" *ngIf="row.PayoutProcessor==3">
                  AxisBank
                </span>
                <span class="" *ngIf="row.PayoutProcessor==4">
                  IDFC
                </span>
              </ng-template>
            </ngx-datatable-column>  
            <ngx-datatable-column name="Updated Date Time">
              <ng-template let-row="row" ngx-datatable-cell-template><div class=" robot font400">{{row.UpdatedDatetime| date:'d/M/yy, h:mm a'}}</div></ng-template>
            </ngx-datatable-column>

          </ngx-datatable>
          </div>
        </div>
</section>








<div  class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
<div class="modal-dialog modal-dialog-centered" role="document">
  <div class="modal-content card-1 p-1">
    <div class="modal-header" style="border-bottom:none">

      <button type="button" class="close blue1-t font-16" data-bs-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">Skip</span>
      </button>
    </div>
    <div class="modal-body"  style="border-bottom:none">
      <div class="row ">
        <div class="mx-auto mb-2">
          <img src="assets/img/new/tour.svg" alt="" height="150">
        </div>
        <div class="col-md-12 text-center">
          <div *ngIf="step1">
            <h4 class="gary-t font-20 pt-3 ">PayOuts</h4>
            <div class="lite-gray-t py-2">
              <h5>FastSwiff Payouts accounts can have balances in two states</h5>
              <ul class="text-left">
                <li>Pending:  funds are not yet available to Payout</li>
                <li>Available: funds can be paid out now</li>
              </ul>
            </div>
            <div class=" text-center" >
              <button class="btn blue-btn"  (click)="next2()">Next</button>
             </div>
          </div>
          <div *ngIf="step2">
           <p>Check your Payout account balance under Manage Payouts</p>





            <div class=" text-center" >
              <button class="btn blue-btn"  (click)="next3()">Next</button>
              <a type="a" class="lite-gra-t font-16 d-block mt-2" (click)="back1()" style="color: #262626;">Back</a>
             </div>
          </div>
          <div *ngIf="step3">
            <p>Check recent transactions and status below the View Account balance under Manage Payouts</p>

            <div class=" text-center" >
              <button class="btn blue-btn" data-bs-dismiss="modal" aria-label="Close" type="button" >Get Started</button>
              <a  type="a" class="lite-gray-t font-16 d-block mt-2" (click)="back2()" style="color: #262626;">Back</a>
               </div>
          </div>

        </div>
      </div>
    </div>

  </div>
</div>
</div>
